import api from 'api';

const path = '/api/auth/reset/password';

export default {
    resetPassword: params => api.post({path, params})
}
